// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dig-list-wrapper {\n\tdisplay: flex;\n\twidth: 100%;\n\tflex-direction: column;\n}\n\n.dig-list-wrapper .dig-actions-placeholder {\n\tmargin-bottom: 5px;\n}\n\n.dig-localization-modal .dig-rows-container {\n\tmax-height: 105px;\n\toverflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
